import { Injectable } from '@angular/core';
//import {HttpClient,HttpHeaders} from "@angular/common/http";
import {Http,Response,Headers} from "@angular/http";
import {UserModel} from "../models/user.model";
import {server,user_store,user_login,client_id,client_secret,grant_type} from "./index.path";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class UserService {
  URL_SINGUP:string = server+user_store;
  URL_LOGIN:string = server+user_login;

  constructor(private http:Http) {

   }

  userSignUp(user:UserModel){
    let headers = new Headers({
      "Content-Type":"application/json"
    });
    user.username = "u"+user.username;
    return this.http.post(this.URL_SINGUP,user,{headers})
                    .map((res: any) => {
                      return res.json();
                    }).catch((err: Response) => {
                      user.username = String(user.username).substr(1);
                      let error = err.json();
                      console.log("fallo servicio userSignUp: "+error.message);
                      if(String(error.message).includes("'users_username_unique'")){
                        alert("El nombre de usuario que elegiste ya esta registrado, intenta con uno diferente");
                      }
                      else if(String(error.message).includes("'users_email_unique'")){
                        alert("El email que ingresaste ya esta registrado, intenta con uno diferente");
                      }
                      else alert("Verifica que  los campos esten completos y la informacion sea correcta");
                      return Observable.throw(error)
                    })
  }

  userLogin(email:string,password:String){
    let headers = new Headers({
      "Content-Type":"application/json"
    });
    let user={
      "email": email,
      "password":password,
      "client_id":client_id,
      "client_secret":client_secret,
      "grant_type":grant_type,
    }
    return this.http.post(this.URL_LOGIN,user,{headers})
                    .map((res: any) => {
                      return res.json();
                    }).catch((err: Response) => {
                      let error = err.json();
                      console.log("fallo servicio userLogin  : "+error.message);
                      alert("Verifica que tu email y Contraseña sean correctos");
                      return Observable.throw(error)
                    })
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/services/user.service.ts